export function errorHandling(location: string, error: { message: string, response?: {status?: number, data: {error: string}}}) {
  console.log(error)
  console.error(`Error in ${location} =>`, error);
  const status = error.response?.status
  const serverError = error.response?.data.error
  const clientError = error.message
  console.log(serverError, status)
  if(serverError && status >= 400){
    return serverError
  }
  if (serverError && status === 401) {
    return serverError;
  }
  if (clientError) return clientError;
}
